import type { Hook } from './types';

import { use } from 'react';

import { PageLoaderContext } from '@/components/common/page-loader';

export const usePageLoader: Hook = () => {
  const { isPageLoading, setIsPageLoading } = use(PageLoaderContext);

  return { isPageLoading, setIsPageLoading };
};
